module.exports = __webpack_public_path__ + "ptc_momoro_F1.69c0fa6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_F1.jpg
// module id = ossa
// module chunks = 0